import React from 'react';
import { Title } from '@mantine/core';
import { Outlet } from 'react-router-dom';

import { usePermissions } from '@/permissions';
import ManifestsTable from './Manifests.table';
import TodoSection from './Todo.section';
import CompletedSection from './Completed.section';
import ConfirmedSection from './Confirmed.section';

export const DashboardPage: React.FC = () => {
  const { isAvailabilityOnly } = usePermissions();

  // The availability_submission role sees only the availability to-do list.
  if (isAvailabilityOnly) {
    return (
      <>
        <Title>Dashboard</Title>
        <TodoSection />
        <Outlet />
      </>
    );
  }

  return (
    <>
      <Title>Dashboard</Title>
      <ManifestsTable />
      <TodoSection />
      <ConfirmedSection />
      <CompletedSection />
      <Outlet />
    </>
  );
};

export default DashboardPage;
